/**
 * KAN-735: стоимость покупки аккаунта, инлайн-редактор в ячейке аккаунта
 * (тот же PATCH, что у метки и имени в переписке). Пусто сохраняется как 0.
 */
import { InlineTextEditor } from '@/components/ui/inline-text-editor';
import { formatRub, parseRubAmount, validateRubAmount } from '@/lib/money';
import type { TelegramAccount } from '@/types/telegramAccount';
import { useAccountPatch } from './useAccountPatch';

const MAX_LENGTH = 12;
const EMPTY_HINT = 'Стоимость покупки не задана';
const SAVE_ERROR = 'Не удалось сохранить стоимость покупки';

export function PurchaseCostEditor({ account }: { account: TelegramAccount }): JSX.Element {
  const key = `${account.operator_id}-${account.account_id}`;
  const cost = account.purchase_cost_rub ?? 0;
  const save = useAccountPatch(account, SAVE_ERROR);

  return (
    <InlineTextEditor
      value={cost ? String(cost) : ''}
      display={cost ? `Покупка: ${formatRub(cost)}` : undefined}
      validate={validateRubAmount}
      onSave={(raw) => save.mutate({ purchase_cost_rub: parseRubAmount(raw) ?? 0 })}
      testId={`purchase-cost-${key}`}
      inputTestId={`purchase-cost-input-${key}`}
      errorTestId={`purchase-cost-error-${key}`}
      ariaLabel="Стоимость покупки, ₽"
      title="Стоимость покупки: нажмите, чтобы изменить"
      maxLength={MAX_LENGTH}
      emptyHint={EMPTY_HINT}
      viewClassName={`mt-0.5 text-xs ${cost ? 'text-gray-700' : 'italic text-gray-500'}`}
      wrapperClassName="mt-0.5"
    />
  );
}
